module.exports = __webpack_public_path__ + "media/images/collapse-8be24586ad3600c71445cdaabc4fcb3e.png";